// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--42660";
export var footerItem = "footer-module--footerItem--f4f0c";
export var footerItemTitle = "footer-module--footerItemTitle--51691";
export var footerList = "footer-module--footerList--ff22f";
export var footerListBottom = "footer-module--footerListBottom--feb34";
export var footerSimple = "footer-module--footerSimple--acb62";
export var footerSimpleWrapper = "footer-module--footerSimpleWrapper--e762e";
export var footerWrapper = "footer-module--footerWrapper--f742a";
export var wrapper = "footer-module--wrapper--743a5";